import { joinData } from "./join";
import { 
  LEFT_JOIN_KEY, 
  RIGHT_JOIN_KEY, 
  APPEND_KEY, 
  INPUT_MAP, 
  INPUT_DATA } from "../config";
import { csv } from "d3-fetch";

export const loadData = () => {
  return Promise.all([
    csv(INPUT_DATA),
    INPUT_MAP
  ]).then(([inputData, inputMap]) => {
    return joinData({
      dataset1: inputMap,
      dataset2: inputData,
      leftJoinOn: LEFT_JOIN_KEY,
      rightJoinOn: RIGHT_JOIN_KEY,
      appendKey: APPEND_KEY
    });
  });
};
